import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.sectionHeader.primary,
  fontWeight: 400,
  '&:first-letter': {
    textTransform: 'capitalize'
  }
}));
